import React from 'react'

function igceadmission() {
  return (
    <div>
      <h1>IGCSE Admission</h1>
    </div>
  )
}

export default igceadmission
